/**
 * K3 Venezuela - Motor de Carrito y Carrusel de Upsells Élite
 * Diseñado para Shopify con soporte de actualización por AJAX,
 * deslizamiento táctil, navegación con flechas y arrastre con ratón.
 */
(function() {
  'use strict';

  // 1. NAVEGACIÓN CON FLECHAS
  window.k3SlideUpsells = function(direction) {
    var list = document.querySelector('#k3-upsells-container .k3-upsells--list') || document.querySelector('.k3-upsells--list');
    if (!list) return;

    var cards = list.querySelectorAll('.k3-up-card');
    if (!cards.length) return;

    var firstCard = cards[0];
    var step = (firstCard.offsetWidth || 240) + 10;
    if (step < 100) step = 250;

    var currentLeft = list.scrollLeft;
    var maxScroll = list.scrollWidth - list.clientWidth;
    var targetLeft = currentLeft + (direction * step);

    if (targetLeft < 0) targetLeft = 0;
    if (targetLeft > maxScroll) targetLeft = maxScroll;

    try {
      list.scrollTo({
        left: targetLeft,
        behavior: 'smooth'
      });
    } catch (e) {
      list.scrollLeft = targetLeft;
    }

    setTimeout(function() {
      window.updateK3NavArrows(list);
    }, 350);
  };

  // 2. ACTUALIZACIÓN VISUAL DE FLECHAS (HABILITADO / DESHABILITADO)
  window.updateK3NavArrows = function(list) {
    if (!list) list = document.querySelector('#k3-upsells-container .k3-upsells--list') || document.querySelector('.k3-upsells--list');
    if (!list) return;
    var wrapper = list.closest('.k3-upsells-wrapper') || document.getElementById('k3-upsells-container');
    if (!wrapper) return;

    var prevBtn = wrapper.querySelector('.k3-nav-prev');
    var nextBtn = wrapper.querySelector('.k3-nav-next');
    if (!prevBtn || !nextBtn) return;

    var sl = list.scrollLeft;
    var max = list.scrollWidth - list.clientWidth - 4;

    if (sl <= 4) {
      prevBtn.style.opacity = '0.35';
      prevBtn.style.pointerEvents = 'none';
      prevBtn.setAttribute('aria-disabled', 'true');
    } else {
      prevBtn.style.opacity = '1';
      prevBtn.style.pointerEvents = 'auto';
      prevBtn.removeAttribute('aria-disabled');
    }

    if (sl >= max) {
      nextBtn.style.opacity = '0.35';
      nextBtn.style.pointerEvents = 'none';
      nextBtn.setAttribute('aria-disabled', 'true');
    } else {
      nextBtn.style.opacity = '1';
      nextBtn.style.pointerEvents = 'auto';
      nextBtn.removeAttribute('aria-disabled');
    }
  };

  // 3. SELECTOR DE CANTIDAD
  window.k3ChangeUpsellQty = function(btn, delta, e) {
    if (e && e.stopPropagation) e.stopPropagation();
    if (!btn) return;
    var ctrl = btn.closest('.k3-up-qty-ctrl');
    if (!ctrl) return;
    var valEl = ctrl.querySelector('.k3-qty-val');
    if (!valEl) return;
    var current = parseInt(valEl.innerText, 10) || 1;
    var next = current + delta;
    if (next < 1) next = 1;
    if (next > 10) next = 10;
    valEl.innerText = next;
  };

  // 4. SELECTOR DE COLOR / SWATCH
  window.k3SelectSwatch = function(swatch, e) {
    if (e && e.stopPropagation) e.stopPropagation();
    if (!swatch) return;
    var card = swatch.closest('.k3-up-card');
    if (!card) return;
    card.querySelectorAll('.k3-swatch').forEach(function(s) { s.classList.remove('active'); });
    swatch.classList.add('active');

    var newVariantId = swatch.getAttribute('data-variant-id');
    var newImg = swatch.getAttribute('data-img');

    card.setAttribute('data-selected-variant', newVariantId);
    var imgEl = card.querySelector('.k3-up-img');
    if (imgEl && newImg) {
      imgEl.style.opacity = '0.4';
      imgEl.src = newImg;
      setTimeout(function() { imgEl.style.opacity = '1'; }, 100);
    }
  };

  // 5. AGREGAR AL CARRITO VÍA AJAX
  window.k3AddUpsell = function(button) {
    if (!button || button.classList.contains('loading') || button.disabled) return;
    var card = button.closest('.k3-up-card');
    if (!card) return;
    var variantId = card.getAttribute('data-selected-variant');
    if (!variantId) return;

    var qtyEl = card.querySelector('.k3-qty-val');
    var qty = qtyEl ? (parseInt(qtyEl.innerText, 10) || 1) : 1;

    button.classList.add('loading');
    button.disabled = true;
    var originalHtml = button.innerHTML;
    button.innerHTML = '<span>...</span>';

    var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) ? window.theme.routes.cart_add_url : '/cart/add.js';

    var sectionsToFetch = ['cart-drawer', 'cart-bubble'];
    if (document.getElementById('Cart')) {
      sectionsToFetch.push('main-cart');
    }

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: qty
        }],
        sections: sectionsToFetch,
        sections_url: window.location.pathname
      })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status && data.status >= 400) {
        throw new Error(data.description || 'Error al agregar producto');
      }

      button.classList.remove('loading');
      button.classList.add('added');
      button.innerHTML = '<span>✓ AGREGADO</span>';

      if (data.sections) {
        var parser = new DOMParser();

        // 1. Actualizar Cart Drawer selectivamente
        var drawer = document.getElementById('Cart-Drawer');
        if (drawer && data.sections['cart-drawer']) {
          var parsedDoc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');

          var currentItems = drawer.querySelector('.product-cart-item--container');
          var newItems = parsedDoc.querySelector('.product-cart-item--container');
          if (currentItems && newItems) {
            currentItems.innerHTML = newItems.innerHTML;
          }

          var currentBadge = drawer.querySelector('.k3-header-badge');
          var newBadge = parsedDoc.querySelector('.k3-header-badge');
          if (currentBadge && newBadge) {
            currentBadge.textContent = newBadge.textContent;
          }

          var currentFooter = drawer.querySelector('.side-panel-footer');
          var newFooter = parsedDoc.querySelector('.side-panel-footer');
          if (currentFooter && newFooter) {
            currentFooter.innerHTML = newFooter.innerHTML;
          }

          if (typeof drawer.removeProductEvent === 'function') {
            drawer.removeProductEvent();
          }
        }

        // 2. Actualizar burbuja
        var bubble = document.getElementById('cart-drawer-toggle');
        if (bubble && data.sections['cart-bubble']) {
          var parsedBubble = parser.parseFromString(data.sections['cart-bubble'], 'text/html');
          var newBubbleContent = parsedBubble.querySelector('.thb-item-count');
          if (newBubbleContent) {
            var bubbleTarget = bubble.querySelector('.thb-item-count') || bubble;
            bubbleTarget.innerHTML = newBubbleContent.innerHTML;
          }
        }

        // 3. Main Cart
        var cartPage = document.getElementById('Cart');
        if (cartPage && data.sections['main-cart']) {
          var parsedCart = parser.parseFromString(data.sections['main-cart'], 'text/html');
          var newCartContent = parsedCart.querySelector('.thb-cart-form');
          if (newCartContent) {
            cartPage.innerHTML = newCartContent.innerHTML;
          }
        }
      }

      document.dispatchEvent(new CustomEvent('cart:item-added', {
        bubbles: true,
        detail: { product: (data.items && data.items[0]) ? data.items[0] : data }
      }));
    })
    .catch(function(err) {
      console.error('Error al agregar upsell:', err);
      button.classList.remove('loading');
      button.disabled = false;
      button.innerHTML = originalHtml;
      alert('No se pudo agregar el producto. Por favor intenta de nuevo.');
    });
  };

  // 6. MOTOR DE ARRASTRE Y RUEDA DE RATÓN (DRAG-TO-SCROLL & WHEEL)
  window.setupK3DragScroll = function() {
    var list = document.querySelector('#k3-upsells-container .k3-upsells--list') || document.querySelector('.k3-upsells--list');
    if (!list) return;
    if (list.dataset.k3DragReady === 'true') {
      window.updateK3NavArrows(list);
      return;
    }
    list.dataset.k3DragReady = 'true';

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    list.addEventListener('mousedown', function(e) {
      if (e.target.closest('button') || e.target.closest('input') || e.target.closest('a') || e.target.closest('.k3-swatch')) return;
      isDown = true;
      list.style.cursor = 'grabbing';
      list.style.scrollBehavior = 'auto';
      list.style.scrollSnapType = 'none';
      startX = e.pageX - list.offsetLeft;
      scrollLeft = list.scrollLeft;
    });

    function stopDrag() {
      if (!isDown) return;
      isDown = false;
      list.style.cursor = '';
      list.style.scrollBehavior = 'smooth';
      list.style.scrollSnapType = 'x proximity';
      window.updateK3NavArrows(list);
    }

    list.addEventListener('mouseleave', stopDrag);
    list.addEventListener('mouseup', stopDrag);

    list.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - list.offsetLeft;
      var walk = (x - startX) * 1.5;
      list.scrollLeft = scrollLeft - walk;
    });

    list.addEventListener('wheel', function(e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        var canLeft = list.scrollLeft > 0;
        var canRight = list.scrollLeft < (list.scrollWidth - list.clientWidth - 2);
        if ((e.deltaY > 0 && canRight) || (e.deltaY < 0 && canLeft)) {
          e.preventDefault();
          list.scrollLeft += e.deltaY * 0.9;
          window.updateK3NavArrows(list);
        }
      }
    }, { passive: false });

    list.addEventListener('scroll', function() {
      window.updateK3NavArrows(list);
    }, { passive: true });

    window.updateK3NavArrows(list);
  };

  // 7. DELEGACIÓN GLOBAL DE EVENTOS (CLICK SEGURO)
  document.addEventListener('click', function(e) {
    var prevBtn = e.target.closest('.k3-nav-prev');
    if (prevBtn) {
      e.preventDefault();
      e.stopPropagation();
      window.k3SlideUpsells(-1);
      return;
    }

    var nextBtn = e.target.closest('.k3-nav-next');
    if (nextBtn) {
      e.preventDefault();
      e.stopPropagation();
      window.k3SlideUpsells(1);
      return;
    }

    var swatch = e.target.closest('.k3-swatch');
    if (swatch && swatch.closest('.k3-upsells-wrapper')) {
      e.preventDefault();
      e.stopPropagation();
      window.k3SelectSwatch(swatch, e);
      return;
    }

    var minusBtn = e.target.closest('.k3-qty-minus');
    if (minusBtn && minusBtn.closest('.k3-upsells-wrapper')) {
      e.preventDefault();
      e.stopPropagation();
      window.k3ChangeUpsellQty(minusBtn, -1, e);
      return;
    }

    var plusBtn = e.target.closest('.k3-qty-plus');
    if (plusBtn && plusBtn.closest('.k3-upsells-wrapper')) {
      e.preventDefault();
      e.stopPropagation();
      window.k3ChangeUpsellQty(plusBtn, 1, e);
      return;
    }

    var addBtn = e.target.closest('.k3-up-add-btn');
    if (addBtn && addBtn.closest('.k3-upsells-wrapper') && !addBtn.hasAttribute('onclick')) {
      e.preventDefault();
      e.stopPropagation();
      window.k3AddUpsell(addBtn);
      return;
    }
  });

  // 8. AUTO-INICIALIZACIÓN ROBUSTA Y OBSERVADOR DE CAMBIOS
  function initK3Cart() {
    window.setupK3DragScroll();

    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && !drawer.dataset.k3Observed) {
      drawer.dataset.k3Observed = 'true';
      var observer = new MutationObserver(function() {
        var list = drawer.querySelector('.k3-upsells--list');
        if (list && list.dataset.k3DragReady !== 'true') {
          window.setupK3DragScroll();
        }
      });
      observer.observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initK3Cart);
  } else {
    initK3Cart();
  }

  document.addEventListener('cart-drawer:open', function() {
    setTimeout(initK3Cart, 50);
  });
  document.addEventListener('cart:item-added', function() {
    setTimeout(initK3Cart, 250);
  });
  document.addEventListener('cart:refresh', function() {
    setTimeout(initK3Cart, 250);
  });
  document.addEventListener('mouseenter', function(e) {
    if (e.target && e.target.closest && e.target.closest('#Cart-Drawer')) {
      initK3Cart();
    }
  }, true);

})();
